import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import Disappointed from '@images/emoji-disappointed.svg'
import Smile from '@images/emoji-smile.svg'
import Unsure from '@images/emoji-unsure.svg'

interface Signature {
  Element: HTMLDivElement
  Args: {
    smile: number
    unsure: number
    disappointed: number
  }
}
export const ReflectionCounter: TOC<Signature> = <template>
  <div class="flex flex-row">
    <div class="ml-6 flex items-center text-2xl"><img
        src={{Smile}}
        alt={{t "pages.recentWriting.reflectionEmojis.smile"}}
        class="w-10"
      /><span class="ml-1">{{@smile}}</span></div>
    <div class="ml-6 flex items-center text-2xl"><img
        src={{Unsure}}
        alt={{t "pages.recentWriting.reflectionEmojis.unsure"}}
        class="w-10"
      /><span class="ml-1">{{@unsure}}</span></div>
    <div class="ml-6 flex items-center text-2xl"><img
        src={{Disappointed}}
        alt={{t "pages.recentWriting.reflectionEmojis.disappointed"}}
        class="w-10"
      /><span class="ml-1">{{@disappointed}}</span></div>
  </div>
</template>

export default ReflectionCounter
